import React from "react";
import SidebarSection from "domains/inference/components/InferenceGenerator/Sidebar/Section";
import { LaunchShortcut } from "domains/shortcuts/components/Shortcut";
import ButtonWithCuIndicator from "domains/ui/components/ButtonWithCuIndicator";
import Divider from "domains/ui/components/Divider";

import { Box } from "@chakra-ui/react";

export interface GenericTriggerButtonProps {
  onClick: () => void;
  label: string;
  isDisabled?: boolean;
  isCuLoading?: boolean;
  cuCost?: number;
  isGenerating?: boolean;
  isAbsolute?: boolean;
  disabledTooltip?: React.ReactNode;
}

export default function GenericTriggerButton({
  onClick,
  label,
  isDisabled,
  isCuLoading,
  cuCost,
  isGenerating,
  isAbsolute,
  disabledTooltip,
}: GenericTriggerButtonProps) {
  return (
    <Box
      {...(isAbsolute && {
        pos: "sticky",
        zIndex: "1",
        right: 0,
        bottom: 0,
        mt: "-1px",
        bg: "secondary.900",
      })}
    >
      {isAbsolute && <Divider />}
      <SidebarSection>
        <ButtonWithCuIndicator
          cuCost={isDisabled ? undefined : cuCost}
          isCuLoading={isDisabled ? false : isCuLoading}
          onClick={onClick}
          isLoading={isGenerating}
          isDisabled={isDisabled}
          w={"100%"}
          tooltip={!isDisabled ? <LaunchShortcut /> : disabledTooltip}
          tooltipProps={{
            placement: "right",
            hasArrow: true,
          }}
        >
          {label}
        </ButtonWithCuIndicator>
      </SidebarSection>
      <Divider />
    </Box>
  );
}
